import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-dialog-push-notification',
  templateUrl: './dialog-push-notification.component.html',
  styleUrls: ['./dialog-push-notification.component.scss']
})
export class DialogPushNotificationComponent {


    constructor(
        public dialogRef: MatDialogRef<DialogPushNotificationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

}
